document.querySelectorAll(".fly-out-cards-main variant-radios").forEach(variantRadiosElement => {
  variantRadiosElement.addEventListener("change", (e) => {
    const container = e.target.closest('.product-form__variant-container');
    container.querySelector(".product-form__variant-active p").textContent = e.target.value;
  });
});

if ( document.querySelector('.fly-out-cards').childElementCount === 0 ) {
  document.querySelector('.fly-out-cards-container').classList.add('hidden');
}

window.flyOutLoad = function () {
  fetch('/?section_id=fly-out')
      .then(response => response.text())
      .then(responseText => {
        let productItem = {};
        document.querySelector(".page-overlay").innerHTML = responseText;
        // document.querySelector('.cart-drawer_column_body').innerHTML = document.querySelector('.cart-drawer__items').outerHTML + responseText;
        document.querySelectorAll('.fly-out-product-card .buttonAddToCart').forEach((addToCart) => {
          addToCart.addEventListener('click', function handleAddToCart(e) {
            const flyOutContainer = e.target.closest('.fly-out-product-card-container');
            const selectedVariantElement = flyOutContainer.querySelector('.product-variant-option:checked');
            let selectedVariant = selectedVariantElement?.dataset?.id || e.target?.dataset?.variant;
            if ( flyOutContainer.querySelectorAll('fieldset').length > 1 ) {
              const variantsData = JSON.parse(flyOutContainer.querySelector('variant-radios').dataset.variants);
              let variantTitle = [];
              flyOutContainer.querySelectorAll('.product-form__variant-active p').forEach(activeValue => variantTitle.push(activeValue.textContent.trim()));
              selectedVariant = variantsData.filter(variant => variant.title === variantTitle.join(' / '))[0].id;
            }
            if (selectedVariant) {
              productItem[e.target.dataset.product] = selectedVariant;
            }
            addAllItems();
          });
        });
        document.querySelectorAll(".fly-out-cards-main variant-radios").forEach(variantRadiosElement => {
          variantRadiosElement.addEventListener("change", (e) => {
            const container = e.target.closest('.product-form__variant-container');
            container.querySelector(".product-form__variant-active p").textContent = e.target.value;
            if(e.target.getAttribute('data-src') !== undefined && e.target.getAttribute('data-src') != '' && e.target.getAttribute('data-src') != null){
              container.closest('.fly-out-product-card-container').querySelectorAll('.variant-img')[0].src = e.target.getAttribute('data-src');
            }
            let variantDiscount = e.target.getAttribute('data-variant-discount');
            let variantDiscountHtml = container.closest('.fly-out-product-card')?.querySelector('.clearance-discount .default-variant-discount');
            if (variantDiscount && variantDiscountHtml) {
              variantDiscountHtml.innerHTML = variantDiscount;
            }
          });
        });
        function getSectionsToRender() {
          return [
            {
              id: 'cart-drawer__content',
              section: document.getElementById('cart-drawer__content').dataset.id,
              selector: '.cart-drawer__content',
            },
            {
              id: 'cart-icon-bubble',
              section: 'cart-icon-bubble',
              selector: '.shopify-section',
            },
          ];
        }
        function addAllItems() {
          let items = [];
          let body = {};
          Object.keys(productItem).forEach(function (key, index) {
            items.push({ id: productItem[key], quantity: 1 });
          });
          body = {
            sections: getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
            items: items,
          };
          fetch(`/cart/add.js`, {
            body: JSON.stringify(body),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest',
            },
            method: 'POST',
          })
            .then((response) => response.json())
            .then((parsedState) => {
              getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                document.querySelector('cart-drawer').createRecommendedProductsList();
              });
              window.flyOutLoad.call(this);
              document.querySelectorAll('.fly-out-product-card .buttonAddToCart').forEach((addToCart) => {
                addToCart.addEventListener('click', function handleAddToCart(e) {
                  const flyOutContainer = e.target.closest('.fly-out-product-card-container');
                  const selectedVariantElement = flyOutContainer.querySelector('.product-variant-option:checked');
                  const selectedVariant = selectedVariantElement?.dataset?.id || e.target?.dataset?.variant;
                  if (selectedVariant) {
                    productItem[e.target.dataset.product] = selectedVariant;
                  }
                  addAllItems();
                });
              });
              document.querySelectorAll(".fly-out-cards-main variant-radios").forEach(variantRadiosElement => {
                variantRadiosElement.addEventListener("change", (e) => {
                  const container = e.target.closest('.fly-out-product-card-container');
                  container.querySelector(".product-form__variant-active p").textContent = e.target.value;
                });
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              productItem = {};
              document.querySelector('cart-drawer').open();
              if (typeof window.updateDiscountAnnouncements === 'function') {
                window.updateDiscountAnnouncements();
              }
              if (typeof window.updateFreeShippingBar === 'function') {
                window.updateFreeShippingBar();
              }
            });
        }
        
        document.querySelectorAll('cart-drawer .fly-out-cards .fly-out-product-card').forEach(item => {
          item.querySelectorAll('variant-radios fieldset').forEach(field => {
            const inputs = field.querySelectorAll('input');
            inputs.forEach(input => {
              input.checked = false;
            });
            if (inputs.length > 0) {
              inputs[0].checked = true;
            }
          });
        });      
        
      })
      .catch(error => console.error(error));
}

window.flyOutLoad();
